import { getClient } from '@/lib/restClient';
import { MosPosOrderService } from '@/services/MosPosOrder/MosPosOrderService';
import {
  MosPosOrderActionResponse,
  MosPosOrderDetailResponse,
  MosPosOrderListParams,
  MosPosOrderListResponse,
  MosPosStoreListResponse,
} from '@/services/MosPosOrder/type';

const getMosPosOrderList = async (
  params: MosPosOrderListParams
): Promise<MosPosOrderListResponse> => {
  const mosPosOrderService = new MosPosOrderService(getClient());
  return await mosPosOrderService.list(params);
};

const getMosPosStoreList = async (): Promise<MosPosStoreListResponse> => {
  const mosPosOrderService = new MosPosOrderService(getClient());
  return await mosPosOrderService.listStores();
};

const getMosPosOrderDetail = async (
  orderId: string
): Promise<MosPosOrderDetailResponse> => {
  const mosPosOrderService = new MosPosOrderService(getClient());
  return await mosPosOrderService.detail(orderId);
};

const resendMosPosOrder = async (
  orderId: string
): Promise<MosPosOrderActionResponse> => {
  const mosPosOrderService = new MosPosOrderService(getClient());
  return await mosPosOrderService.resend(orderId);
};

const cancelMosPosOrder = async (
  orderId: string
): Promise<MosPosOrderActionResponse> => {
  const mosPosOrderService = new MosPosOrderService(getClient());
  return await mosPosOrderService.cancel(orderId);
};

export {
  cancelMosPosOrder,
  getMosPosOrderDetail,
  getMosPosOrderList,
  getMosPosStoreList,
  resendMosPosOrder,
};
